
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteU as ObiOwnShipRemoteUElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-u.js';
 
 
 

 
 export const ObiOwnShipRemoteU = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-u',
   elementClass: ObiOwnShipRemoteUElement,
   events: {
     
   }
  });
 
 